import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/button-smasher/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={789}
              height={902}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#DB2F91" }}>Solution</span>
            </h2>
            <p>
              Our team worked extensively to adopt a dual-rating system which
              implements an aggregate rating based on individual components of a
              game such as graphics, gameplay, animation and sound. For this,
              two modules were created. One for ratings from game critics and a
              separate module for casual players. This ensured that consumers
              could see distinct ratings from random people and game critics, to
              get a more educated experience when seeing game ratings and
              reviews.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
